import React from "react";
import { Box } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialPad({
  dialValue,
  onChangeDial,
  onAppend,
  darkMode,
}) {
  return (
    <>
      <MDInput
        fullWidth
        value={dialValue}
        onChange={onChangeDial}
        inputProps={{ maxLength: 32 }}
        sx={{
          mb: 2,
          borderRadius: 2,
          "& .MuiOutlinedInput-root": {
            background: darkMode
              ? "linear-gradient(135deg, rgba(30, 30, 50, 0.8) 0%, rgba(40, 40, 60, 0.8) 100%)"
              : "linear-gradient(135deg, rgba(230, 240, 255, 0.6) 0%, rgba(210, 230, 255, 0.6) 100%)",
            border: "2px solid transparent",
            backgroundImage: darkMode
              ? "linear-gradient(135deg, rgba(30, 30, 50, 0.8) 0%, rgba(40, 40, 60, 0.8) 100%), linear-gradient(135deg, #42a5f5 0%, #1976d2 100%)"
              : "linear-gradient(135deg, rgba(230, 240, 255, 0.6) 0%, rgba(210, 230, 255, 0.6) 100%), linear-gradient(135deg, #42a5f5 0%, #1976d2 100%)",
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box, border-box",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              borderColor: "#42a5f5",
              boxShadow: darkMode
                ? "0 8px 24px rgba(66, 165, 245, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
                : "0 8px 24px rgba(66, 165, 245, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3)",
            },
            "&.Mui-focused": {
              borderColor: "#1976d2",
              boxShadow: darkMode
                ? "0 12px 32px rgba(66, 165, 245, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
                : "0 12px 32px rgba(66, 165, 245, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.3)",
            },
          },
          "& .MuiOutlinedInput-input": {
            fontSize: "18px",
            fontWeight: 600,
            letterSpacing: "2px",
            color: darkMode ? "#e0e0e0" : "#1976d2",
            padding: "12px 16px",
            "&::placeholder": {
              color: darkMode
                ? "rgba(200, 200, 200, 0.5)"
                : "rgba(25, 118, 210, 0.5)",
              opacity: 1,
            },
          },
        }}
      />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
          mb: 1,
        }}
      >
        {[
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "*",
          "0",
          "#",
        ].map((k) => (
          <MDButton
            key={k}
            variant="contained"
            onClick={() => onAppend(k)}
            sx={{
              fontSize: "18px",
              fontWeight: 800,
              padding: "12px",
              background: darkMode
                ? "linear-gradient(135deg, rgba(66, 165, 245, 0.9) 0%, rgba(33, 150, 243, 0.8) 100%)"
                : "linear-gradient(135deg, #42a5f5 0%, #2196f3 100%)",
              color: "#ffffff",
              textShadow: darkMode
                ? "0 1px 2px rgba(0, 0, 0, 0.5)"
                : "0 1px 1px rgba(0, 0, 0, 0.2)",
              borderRadius: "12px",
              boxShadow: darkMode
                ? "0 6px 20px rgba(33, 150, 243, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)"
                : "0 6px 20px rgba(33, 150, 243, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.3)",
              transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "none",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)",
                transition: "left 0.5s ease",
              },
              "&:hover": {
                transform: "translateY(-4px) scale(1.05)",
                boxShadow: darkMode
                  ? "0 12px 32px rgba(33, 150, 243, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.3)"
                  : "0 12px 32px rgba(33, 150, 243, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.4)",
                background: darkMode
                  ? "linear-gradient(135deg, rgba(100, 181, 246, 1) 0%, rgba(66, 165, 245, 0.9) 100%)"
                  : "linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%)",
              },
              "&:hover::before": {
                left: "100%",
              },
              "&:active": {
                transform: "translateY(-2px) scale(1.02)",
                boxShadow: darkMode
                  ? "0 4px 12px rgba(33, 150, 243, 0.4)"
                  : "0 4px 12px rgba(33, 150, 243, 0.3)",
              },
            }}
          >
            {k}
          </MDButton>
        ))}
      </Box>
    </>
  );
}
